import { useEffect } from 'react';
import { stopEventPropagation } from '@frameio/utils';
import { MenuButton, MenuGroup, MenuSwitch } from '@frameio/vapor';
import { IconCog, IconNotifications } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/ProjectSwitcherProjectMenu';

type ProjectSwitcherProjectMenuProps = {
  hasNotificationsEnabled: boolean;
  // Optional callback to be called when the menu is shown
  onMount?: () => void;
  onSelectNotifications?: () => void;
  onSettingsClick?: () => void;
  isShowing?: boolean;
};

/**
 * Menu component for project switcher with notification toggle and settings
 */
export const ProjectSwitcherProjectMenu = ({
  hasNotificationsEnabled = false,
  onSelectNotifications,
  onSettingsClick,
  onMount,
}: ProjectSwitcherProjectMenuProps) => {
  useEffect(() => {
    onMount?.();
  }, [onMount]);

  const settingsDisabled = !onSettingsClick;

  return (
    <div onClick={stopEventPropagation}>
      <MenuGroup data-testid="project-switcher--menu" label={TEXT.project}>
        <MenuSwitch
          checked={hasNotificationsEnabled}
          iconBefore={<IconNotifications />}
          name={TEXT.notifications}
          onPress={onSelectNotifications}
        >
          {TEXT.notifications}
        </MenuSwitch>

        {!settingsDisabled && (
          <MenuButton
            data-testid="project-switcher--menu--settings-button"
            disabled={settingsDisabled}
            iconBefore={<IconCog />}
            onClick={onSettingsClick}
          >
            {TEXT.projectSettings}
          </MenuButton>
        )}
      </MenuGroup>
    </div>
  );
};

TEXT.DEFINE({
  /** Menu item label that opens project settings from the project switcher menu */
  projectSettings: 'Project Settings',
  /** Label for the project notifications toggle in the project switcher menu */
  notifications: 'Notifications',
  /** Menu group label for project-related actions in the project switcher */
  project: 'Project',
});
